import { Typography } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import Rows from "../../library/components/layout/Rows";
import Columns from "../../library/components/layout/Columns";
import appColors from "../../app/appColors";
import PasswordPolicyHelper from "../../library/helpers/PasswordPolicyHelper";

interface IPasswordPolicyChecklistProps {
    password: string;
}

// Yeni parola politikası kuralları için gerçek-zamanlı, kural-bazlı geri bildirim.
// Kurallar PasswordPolicyHelper'da tanımlı (backend ile aynalı).
// Politika yalnız prod'da zorlandığı için dev/test'te hiç çizilmez (yanıltıcı kırmızı gösterme).
function PasswordPolicyChecklist(props: IPasswordPolicyChecklistProps) {
    if (!PasswordPolicyHelper.zorunluMu())
        return null;

    const kurallar = PasswordPolicyHelper.kurallar(props.password);

    return (
        <Rows mb={10}>
            {kurallar.map((kural, index) => (
                <Columns key={index} mb={2} style={{ alignItems: "center" }}>
                    {kural.gecerli
                        ? <CheckCircleIcon style={{ fontSize: 16, color: appColors.GREEN_MAIN, marginRight: 6 }} />
                        : <RadioButtonUncheckedIcon style={{ fontSize: 16, color: appColors.RED_MAIN, marginRight: 6 }} />}
                    <Typography style={{ fontSize: 12, color: kural.gecerli ? appColors.GREEN_MAIN : appColors.RED_MAIN }}>
                        {kural.mesaj}
                    </Typography>
                </Columns>
            ))}
        </Rows>
    );
}

export default PasswordPolicyChecklist;
